module.exports = __webpack_public_path__ + "img/nl-nl.c0c73ab9.svg";